
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resource-center/reviewers",
      function () {
        return require("private-next-pages/resource-center/reviewers/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/resource-center/reviewers"])
      });
    }
  